import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import PageView from '@/components/layout/PageView'
import OpenInstrument from '@/views/openInstrument/openInstrument'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PageView',
    component: PageView,
    redirect: '/home',
    meta: { title: '首页' },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/home'),
        meta: { title: '首页' },
      },
      {
        path: '/infoDelivery',
        name: 'infoDelivery',
        component: () => import('@/views/infoDelivery'),
        meta: { title: '信息发布' },
      },
      // {
      //   path: '/login',
      //   name: 'login',
      //   component: () => import('@/views/Login'),
      //   meta: { title: '预约入口' },
      // },
      {
        path: '/page/xinwen',
        name: 'xinwen',
        component: () => import('@/views/xinwen/xinwen'),
        meta: { title: '中心新闻' },
      },
      {
        path: '/page/xinwenDetail',
        name: 'xinwenDetail',
        component: () => import('@/views/xinwen/xinwenDetail'),
        meta: { title: '中心新闻' },
      },
      {
        path: '/page/survey',
        name: 'survey',
        component: () => import('@/views/survey/survey'),
        meta: { title: '中心概况' },
      },
      {
        path: '/page/surveyDetail',
        name: 'surveyDetail',
        component: () => import('@/views/survey/surveyDetail'),
        meta: { title: '中心概况' },
      },
      {
        path: '/page/notice',
        name: 'notice',
        component: () => import('@/views/notice/notice'),
        meta: { title: '通知公告' },
      },
      {
        path: '/page/noticeDetail',
        name: 'noticeDetail',
        component: () => import('@/views/notice/noticeDetail'),
        meta: { title: '通知公告' },
      },
      {
        path: '/page/userGuide',
        name: 'userGuide',
        component: () => import('@/views/userGuide/userGuide'),
        meta: { title: '用户指南' },
      },
      {
        path: '/page/userGuideDetail',
        name: 'userGuideDetail',
        component: () => import('@/views/userGuide/userGuideDetail'),
        meta: { title: '用户指南' },
      },
      {
        path: '/page/wendang',
        name: 'wendang',
        component: () => import('@/views/wendang/wendang'),
        meta: { title: '文档下载' },
      },
      {
        path: '/page/rulers',
        name: 'rulers',
        component: () => import('@/views/rulers/rulers'),
        meta: { title: '规章制度' },
      },
      {
        path: '/page/rulersDetail',
        name: 'rulersDetail',
        component: () => import('@/views/rulers/rulersDetail'),
        meta: { title: '规章制度' },
      },
      {
        path: '/page/contact',
        name: 'contact',
        component: () => import('@/views/contact/contact'),
        meta: { title: '联系我们' },
      },
      // {
      //   path: '/page/notice',
      //   name: 'DayiNotice',
      //   component: () => import('@/views/dayiNotice/dayiNotice'),
      //   meta: { title: '通知公告' },
      // },
      // {
      //   path: '/page/noticeDetail',
      //   name: 'NoticeDetail',
      //   component: () => import('@/views/dayiNotice/noticeDetail'),
      //   meta: { title: '通知公告' },
      // },
      // {
      //   path: '/page/school',
      //   name: 'SchoolNotice',
      //   component: () => import('@/views/infoNotice/school/index'),
      //   meta: { title: '学校通知' },
      // },
      // {
      //   path: '/page/schoolDetail',
      //   name: 'SchoolDetail',
      //   component: () => import('@/views/infoNotice/school/detail'),
      //   meta: { title: '学校通知' },
      // },
      // {
      //   path: '/page/training',
      //   name: 'TrainingNotice',
      //   component: () => import('@/views/infoNotice/training/index'),
      //   meta: { title: '培训通知' },
      // },
      // {
      //   path: '/page/trainingDetail',
      //   name: 'TrainingDetail',
      //   component: () => import('@/views/infoNotice/training/detail'),
      //   meta: { title: '培训通知' },
      // },
      {
        path: '/page/instrument',
        name: 'Instrument',
        component: OpenInstrument,
        meta: { title: '开放仪器' },
        redirect: '/page/instrument/list',
        children: [
          {
            path: '/page/instrument/list',
            name: 'InstrumentList',
            component: () => import('@/views/openInstrument/instrumentList'),
            meta: { title: '仪器列表' },
          },
          {
            path: '/page/instrument/detail',
            name: 'InstrumentDetail',
            component: () => import('@/views/openInstrument/instrumentDetail'),
            meta: { title: '仪器详情' },
            redirect: '/page/instrument/detail/yiqiDetail',
            children: [
              {
                path: '/page/instrument/detail/yiqiDetail',
                name: 'DayiDetail',
                component: () => import('@/views/dayiDetail/dayiDetail'),
                meta: { title: '仪器详细信息' },
              },
              {
                path: '/page/instrument/detail/yiqiReserve',
                name: 'DayiReserve',
                component: () => import('@/views/dayiReserve/dayiReserve'),
                meta: { title: '仪器预约' },
              },
              {
                path: '/page/instrument/detail/yiqiOption',
                name: 'DayiOption',
                component: () => import('@/views/dayiOption/dayiOption'),
                meta: { title: '自主操作培训' },
              },
              {
                path: '/page/instrument/detail/yiqiConsult',
                name: 'DayiConsult',
                component: () => import('@/views/dayiConsult/dayiConsult'),
                meta: { title: '咨询建议' },
              },
              {
                path: '/page/instrument/detail/yiqiHistory',
                name: 'DayiHistory',
                component: () => import('@/views/dayiHistory/dayiHistory'),
                meta: { title: '历史记录' },
              },
              {
                path: '/page/instrument/detail/yiqiOtRecord',
                name: 'DayiOtRecord',
                component: () => import('@/views/dayiOtRecord/dayiOtRecord'),
                meta: { title: '操作记录' },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/components/layout/404'),
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
